import * as React from "react";
import { Helmet } from "react-helmet";
import { DIVIDER } from "baseui/table-semantic";
import { Link } from "kanopi-components/Link";
import { SummaryCard } from "kw/admin/components/SummaryCard";
import { SummaryTable } from "kw/admin/components/SummaryTable";
import { useBreakpoint } from "kanopi-components/useBreakpoint";
import { useContactUs } from "./useContactUs";
import { useUser } from "kw/auth/useUser";

export const ContactUsCard: React.FC = () => {
  const { contactUs } = useContactUs();
  const { isSmall } = useBreakpoint();
  const user = useUser();

  const sendEmail = (e) => {
    e.preventDefault();
    window.open(`mailto:${contactUs?.emailAddress}`, "_blank");
  };

  const columnSchema = [
    {
      header: "",
      id: "id",
      children: (row) => row?.label,
      sortable: false,
      overrides: {
        TableBodyCell: {
          style: () => ({
            paddingLeft: 0,
            whiteSpace: isSmall ? "normal" : "nowrap",
          }),
        },
      },
    },
    {
      header: "",
      id: "id",
      children: (row) => row?.value,
      sortable: false,
      overrides: {
        TableBodyCell: {
          style: () => ({
            width: "100%",
          }),
        },
      },
    },
  ];
  const data = [
    contactUs?.operatingHours && {
      id: "1",
      label: "Support operation hours",
      value: contactUs?.operatingHours,
    },
    contactUs?.phoneDisplay && {
      id: "2",
      label: "Phone",
      value: contactUs?.phoneDisplay,
    },
    contactUs?.emailAddress && {
      id: "3",
      label: "Email",
      value: (
        <Link href="#" onClick={sendEmail}>
          {contactUs?.emailAddress}
        </Link>
      ),
    },
    contactUs?.website && {
      id: "4",
      label: "Website",
      value: (
        <Link href={contactUs?.website || "#"} target="_blank">
          {contactUs?.website}
        </Link>
      ),
    },
  ];
  return (
    <>
      <Helmet>
        <title>Contact Us - {user?.organization?.name}</title>
      </Helmet>
      <SummaryCard title="Support">
        <SummaryTable
          data={data}
          columnSchema={columnSchema}
          divider={DIVIDER.clean}
          overrides={{
            TableBodyRow: {
              style: {
                ":first-child td": {
                  borderTopWidth: 0,
                  borderTopStyle: "none",
                },
              },
            },
          }}
        />
      </SummaryCard>
    </>
  );
};
